<template>
  <div>
    <CModuleHeader 
      :horizontalMargin="2" 
      @mouseenter="emitContextualHelpChanged('seats')"
      @mouseleave="emitContextualHelpChanged(null)"
      class="text-over"
    >{{ $t('roomSeats') }}</CModuleHeader>

    <CModuleContent
      :height="24"
      :horizontalMargin="2"
    >
      <div v-for="(seat, index) in renderSeats" :key="'row_' + index + seats" class="row" :class="index === 0 ? 'mt-3' : 'mt-2'">
        <div class="col-4">{{ $t('row') }} {{ index + 1 }}</div>
        <div class="col-8">
          <TrinnovInput
            buttonType="numberIncrement"
            :id="index"
            :modelValue="seat"
            :min="index + 1 === seats.length ? 0 : 1"
            :max="8"
            :isDisabled="algoSelected === 'custom' ? true : false"
            size="auto"
            :event="true"
            @TrinnovInputChanged="emitNbSeatsChanged"
          ></TrinnovInput>
        </div>
      </div>

      <div v-if="seats && seats.length <= 4" class="add-class">
        <TrinnovInput
          buttonType="buttonIcon"
          id="add"
          :modelValue="algoSelected !== 'custom' ? true : false"
          :svgPath="require('@/lib/tui/assets/common/increment/plus.svg')"
          size="auto"
          :event="true"
          :isDisabled="algoSelected === 'custom' ? true : false"
          @TrinnovInputChanged="emitNewRow"
        ></TrinnovInput>
      </div>
    </CModuleContent>
  </div>
</template>

<script>
import CModuleHeader from "@/lib/tui/template/container/module/CModuleHeader.vue";
import CModuleContent from "@/lib/tui/template/container/module/CModuleContent.vue";
import TrinnovInput from "@/lib/tui/components/buttons/TrinnovInput.vue";
export default {
  name: "CSeats",
  ///////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////
  components: {
    TrinnovInput,
    CModuleHeader,
    CModuleContent
  },
  ///////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////
  props: {
    seats: Array,
    forceUpdate: Boolean,
    algoSelected: String
  },
  ///////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////
  methods: {
    emitNewRow: function() {
      this.$emit("NewRow");
    },
    ///////////////////////////////////////////////////////////////
    emitNbSeatsChanged: function(event) {
      this.$emit("NbSeatsChanged", { row: event.id, value: event.value });
    },
    ///////////////////////////////////////////////////////////////
    emitContextualHelpChanged: function(event) {
      this.$emit("ContextualHelpChanged", event);
    }
  },
  ///////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////
  computed: {
    renderSeats: function() {
      return this.seats;
    }
  },
  ///////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////
  watch: {
    forceUpdate: function() {
      this.$forceUpdate();
    }
  }
}
</script>

<style lang="scss" scoped>
  .add-class {
    text-align: left;
    margin-left: 2vw;
    margin-top: 2vh;
  }
</style>